import React, { ChangeEvent } from 'react';

import { Control, FieldErrors, UseFormHandleSubmit, UseFormSetValue } from 'react-hook-form';

import useUserHook from 'hooks/useUserHook';

import { MuiIcon } from 'components/common/muiIcon/muiIcon';

import {
    ADDITION_OPTIONS,
    IFields,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/addAssociatedDocuments';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/mobile/addAssociatedDocuments.mobile.module.scss';
import { formatNameForUplodaedFile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addAssociatedDocuments/mobile/addAssociatedDocuments.mobile.utils';
import { AddLinkToFile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/addLinkToFile/AddLinkToFile';
import { CustomizedButton, CustomizedModalBase } from 'components/common';

interface Props {
    showAddAssociatedDocuments: boolean;
    handleCancel: () => void;
    handleSubmit: UseFormHandleSubmit<IFields, IFields>;
    handleSave: (data: any) => void;
    documentMode: ADDITION_OPTIONS | null;
    setDocumentMode: React.Dispatch<React.SetStateAction<ADDITION_OPTIONS | null>>;
    handleFileChosen: (file: File) => void;
    errors: FieldErrors<IFields>;
    control: Control<IFields, any, IFields>;
    setValue: UseFormSetValue<IFields>;
}

const imagesExtensions = ['jpg', 'jpeg', 'png'];

export const AddAssociatedDocumentsMobile = ({
    showAddAssociatedDocuments,
    handleCancel,
    handleSubmit,
    handleSave,
    documentMode,
    setDocumentMode,
    handleFileChosen,
    errors,
    control,
    setValue,
}: Props) => {
    const { firstName, lastName } = useUserHook();
    const handleFileChosenMobile = (e: ChangeEvent<HTMLInputElement>): void => {
        if (e.target.files && e.target.files.length > 0) {
            const originalFile = e.target.files[0];
            const originalFileNameSplitted = originalFile.name.split('.');
            const originalFileExtension = originalFileNameSplitted[originalFileNameSplitted.length - 1];
            if (imagesExtensions.includes(originalFileExtension)) {
                let formatedFileName = formatNameForUplodaedFile(firstName, lastName).concat(
                    `.${originalFileExtension}`,
                );

                const renamedFile = new File([originalFile], formatedFileName, {
                    type: originalFile.type,
                    lastModified: originalFile.lastModified,
                });
                handleFileChosen(renamedFile);
            } else {
                handleFileChosen(originalFile);
            }
        }
    };

    return (
        <CustomizedModalBase
            modalStyles={{
                width: '450px',
                height: 'fit-content',
            }}
            isModalOpen={showAddAssociatedDocuments}
            handleModalClose={handleCancel}
        >
            <form
                data-testid={'add-associated-documents-container'}
                className={classes.addAssociatedDocumentsContainer}
                onSubmit={(e) => {
                    e.stopPropagation();
                    return handleSubmit(handleSave)(e);
                }}
            >
                <div className={classes.title}>Attachments</div>
                {documentMode === null && (
                    <div className={classes.buttonsWrapper}>
                        <div className={classes.iconWithButton}>
                            <MuiIcon icon={'link'} fontSize="3rem" />
                            <CustomizedButton
                                onClick={() => {
                                    setDocumentMode('addLink');
                                }}
                                variant={'text'}
                                size={'large'}
                            >
                                <span className={classes.actionName}>Add Link to File</span>
                            </CustomizedButton>
                        </div>
                        <div className={classes.iconWithButton}>
                            <MuiIcon icon={'article'} fontSize="3rem" />
                            <CustomizedButton
                                size={'large'}
                                variant={'text'}
                                component={'label'}
                                id={'associated-document-upload-file-button'}
                            >
                                <input
                                    type="file"
                                    id="file"
                                    hidden
                                    accept=".jpg, .png, .jpeg, .gif, .txt, .pdf, .csv, .xls, .xlsx, .doc, .docx, .ppt, .pptx"
                                    onChange={(e) => handleFileChosenMobile(e)}
                                />
                                <span className={classes.actionName}>Upload File From Device</span>
                            </CustomizedButton>
                        </div>
                    </div>
                )}
                {documentMode === 'addLink' && (
                    <AddLinkToFile errors={errors} setValue={setValue} control={control} handleCancel={handleCancel} />
                )}
            </form>
        </CustomizedModalBase>
    );
};
